'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _shopifyCartjs = require('shopify-cartjs');

var _shopifyCartjs2 = _interopRequireDefault(_shopifyCartjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    _shopifyCartjs2.default.init(window.cartData, window.cartDataSettings);
});